export enum ResourceType {
  project = 'project',
  address = 'address',
  activity = 'activity',
}
